import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  withWordmark?: boolean;
}

export function Logo({ className, withWordmark = true }: LogoProps) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <svg
        width="16"
        height="22"
        viewBox="0 0 16 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <path
          d="M2 2 L14 2 L14 20 L2 20 Z M5 6 L11 6 M5 11 L11 11 M5 16 L11 16"
          stroke="var(--color-ember)"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </svg>
      {withWordmark && (
        <span
          className="text-[15px] font-semibold tracking-[0.005em] text-[var(--color-snow)]"
          style={{ fontFamily: "var(--font-sans)" }}
        >
          EON.HEALTH
        </span>
      )}
    </span>
  );
}
